import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Icon from '@comp/Icon.vue';
import FollowButton from '@comp/parts/FollowButton.vue';
import BlockUserButton from '@comp/parts/BlockUserButton.vue';
import UserAvatar from '@comp/base/UserAvatar.vue';
import FireIcon from '!!url-loader?!@static/icons/s-fire.svg';
import EditIcon from '!!url-loader?!@static/icons/s-edit.svg';
import UsersIcon from '!!url-loader?!@static/icons/s-users.svg';
import JobIcon from '!!url-loader?!@static/icons/s-job.svg';
import UniversityIcon from '!!url-loader?!@static/icons/s-university.svg';
import MapIcon from '!!url-loader?!@static/icons/s-map.svg';
import ArrowIcon from '!!url-loader?!@static/icons/s-arrow-left.svg';
import SidebarStatisticIcon from '!!url-loader?!@static/icons/sidebar-statistic.svg';
import UserVerificationIcon from '!!url-loader?!@static/icons/user-verification.svg';
import { mapActions, mapState, mapGetters } from 'vuex';
import { WindowWidth } from '@utils/window-width';
import { contentReplaceLink, getInnerContentLength, contentParser } from '@utils/parserContent';
import BlockUserModal from '@comp/modals/BlockUserModal.vue';
import { BLOCKING_STATUSES } from '@utils/constants';
export default {
  components: {
    BlockUserModal: BlockUserModal,
    Icon: Icon,
    FollowButton: FollowButton,
    BlockUserButton: BlockUserButton,
    UserAvatar: UserAvatar
  },
  props: {
    followingStatus: String,
    followLoading: Boolean,
    userPhotoUrl: String,
    userName: String,
    firstName: String,
    lastName: String,
    userNickname: String,
    isPrivate: Boolean,
    userNick: String,
    rankIcon: String,
    rankPlace: Number,
    onlineStatus: String,
    followers: Object,
    job: Object,
    university: Array,
    location: Object,
    descr: String,
    followingTotal: Number,
    followingUsers: Array,
    userStatistics: Object,
    folowingUserPage: Number,
    folowingUserPageCount: Number,
    folowingUserHasNextPage: Boolean,
    folowingLoad: Boolean,
    leaderBoardPosition: Number,
    hotBoardPosition: Number,
    verified: Boolean,
    blockingStatus: String,
    blockLoading: Boolean,
    leaveOnlyHead: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readMoreActivated: false,
      FireIcon: FireIcon,
      EditIcon: EditIcon,
      UsersIcon: UsersIcon,
      JobIcon: JobIcon,
      UniversityIcon: UniversityIcon,
      MapIcon: MapIcon,
      ArrowIcon: ArrowIcon,
      SidebarStatisticIcon: SidebarStatisticIcon,
      UserVerificationIcon: UserVerificationIcon,
      WindowWidth: WindowWidth
    };
  },
  BLOCKING_STATUSES: BLOCKING_STATUSES,
  computed: _objectSpread(_objectSpread({}, mapGetters('auth', ['isAuthenticated'])), {}, {
    contentReplace: function contentReplace() {
      if (this.descr) {
        return contentReplaceLink(this.descr);
      }

      return this.descr;
    },
    contentHasMore: function contentHasMore() {
      var contentLength = getInnerContentLength(this.contentReplace);
      return contentLength > 186;
    },
    isUserBlocked: function isUserBlocked() {
      return this.isAuthenticated && [BLOCKING_STATUSES.USER_BLOCKED, BLOCKING_STATUSES.BLOCKED_BY_USER].includes(this.blockingStatus);
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('userBlocking', ['unblock'])), {}, {
    showAuth: function showAuth() {
      if (this.isAuthenticated) {
        this.$emit('follow');
      } else {
        this.$store.commit('auth/setAuthPopup', {
          show: true
        });
      }
    },
    contentHtml: function contentHtml() {
      var maxContentLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;

      if (this.contentReplace) {
        var contentArray = contentParser(this.contentReplace, maxContentLength);

        if (!contentArray) {
          return this.contentReplace;
        }

        var _contentHtml = '';

        var getContent = function getContent(contentItem) {
          if (contentItem.tag) {
            var innerContent = '';
            contentItem.content.forEach(function (innerItem) {
              innerContent += getContent(innerItem);
            });
            return "".concat(contentItem.tag).concat(innerContent, "</").concat(contentItem.tagName, ">");
          }

          return contentItem.contentStr;
        };

        contentArray.forEach(function (contentItem) {
          _contentHtml += getContent(contentItem);
        });
        return _contentHtml;
      }

      return this.contentReplace;
    },
    changePhoto: function changePhoto() {
      if (this.followingStatus === 'you') {
        this.$router.push({
          name: 'UserProfile',
          params: {
            openMainInfo: true
          }
        });
      }
    },
    blockUserModalOpen: function blockUserModalOpen() {
      if (this.isAuthenticated) {
        this.$refs.blockModal.open();
      } else {
        this.$store.commit('auth/setAuthPopup', {
          show: true
        });
      }
    }
  })
};